import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-reports-reception',
  templateUrl: './reports-reception.component.html',
  styleUrl: './reports-reception.component.scss'
})
export class ReportsReceptionComponent {
  constructor(
    private router: Router
  ){}

  ngOnInit(): void {
  }

  routeTo(route: string): void {
    this.router.navigate([route]);
  }

}
